import { map_style } from './map-style'

export function map()
{
	const google = window.google;

	/*
		*  new_map
		*  This function will render a Google Map onto the selected jQuery element
		*/
	function new_map($el)
	{
		// var
		var $markers = $el.find('.marker');

		// vars
		var args = {
				zoom: 6,
				center: new google.maps.LatLng(0, 0),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: map_style,
				mapTypeControl: false,
				disableDefaultUI: true,
		};

		// create map
		var map = new google.maps.Map($el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function() {
			var url = $(this).attr('data-icon');

			let icon = {
					url: url,
					anchor: new google.maps.Point(13, 13),
					scaledSize: new google.maps.Size(26, 26),
			}

			add_marker($(this), map, icon);
		});

		// center map
		center_map(map);

		// return
		return map;
}

	/*
		* add_marker
		* This function will add a marker to the selected Google Map
		*/

	function add_marker($marker, map, icon)
	{
		// var
		var latlng = new google.maps.LatLng(
			$marker.attr('data-lat'),
			$marker.attr('data-lng')
		);

		// create marker
		var marker = new google.maps.Marker({
				position: latlng,
				map: map,
				icon: icon,
		});

		// add to array
		map.markers.push(marker);
	}

	/**
	 *  center_map
	 *  This function will center the map, showing all markers attached to this map
	 */

	function center_map(map)
	{
			// vars
			var bounds = new google.maps.LatLngBounds();

			// loop through all markers and create bounds
			$.each(map.markers, function(i, marker) {
				var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

				bounds.extend(latlng);
			});

			// only 1 marker?
			if (map.markers.length == 1) {
				// set center of map
				map.setCenter(bounds.getCenter());
				map.setZoom(16);
			} else {
				// fit to bounds
				map.fitBounds(bounds);
			}
	}

	/*
	 * document ready
	 * This function will render each map when the document is ready (page has loaded)
	 *
	 * Map global var
	 * That will get overidden
	 */

	var map = null;

	// Create map
	function maps()
	{
		$('.acf-map').each(function ()
		{
			map = new_map($(this));
		});
	}
	
	maps();
}

export function mapHeightToggle()
{
	let mapBlock = document.querySelectorAll('.acf-map');

	mapBlock.forEach((map) => {
		map.addEventListener('click', () => {
			map.classList.toggle('active');
		})
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/map.js